import { authFetch } from "../../../../../HttpClient";

// Les 5 handlers handleSubmitXxx du suivi comptable partagent 3 blocs
// identiques (seuls les endpoints/payloads changent) :
//   1. création éventuelle d'un ToDo lié à l'étape,
//   2. POST du formulaire principal -> extraction du tacheId,
//   3. bloc "fire-and-forget" en arrière-plan : historique-client,
//      compta/tache/:id/statut, email-xxx, et (étapes 2 à 5) fermeture du
//      ToDo de l'étape précédente.
// On factorise ces 3 blocs ici ; chaque étape ne fournit que ce qui lui est
// propre (arrivePC n'a pas de "todo précédent" à fermer — c'est la première
// étape ; bouclage ne crée pas de ToDo — c'est la dernière, ces différences
// réelles ne sont pas gommées).

// 1. Création du ToDo lié à l'étape suivante.
// - arrivePC : erreur de création => on relance (rethrowOnError), le
//   handleSubmit échoue entièrement (comportement d'origine).
// - tri / traitement1 / traitement2 : erreur de création => avalée
//   (console.error), todoId reste null, le formulaire principal est quand
//   même envoyé (comportement d'origine).
export async function createLinkedTodo({
  title,
  selectedClient,
  userIds,
  commentaire,
  rethrowOnError = false,
}) {
  const dueDate = new Date();
  dueDate.setDate(dueDate.getDate() + 2);
  const dueDateString = dueDate.toISOString().split("T")[0];

  try {
    const todoPayload = {
      title,
      status: "En cours",
      type: "autres",
      nomClient: selectedClient.nom,
      clientId: selectedClient.id,
      formLeadId: null,
      eventId: null,
      userIds,
      nature: "compta",
      dueDate: dueDateString,
      priority: "classique",
      commentaire,
    };

    const todoRes = await authFetch("https://backend-myalfa.vercel.app/api/todos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(todoPayload),
    });

    if (!todoRes.ok) throw new Error("Erreur lors de la création du todo");

    const createdTodo = await todoRes.json();
    return createdTodo.id;
  } catch (todoError) {
    console.error("Erreur lors de la création du todo :", todoError);
    if (rethrowOnError) throw todoError;
    return null;
  }
}

// 2. POST du formulaire principal /api/compta/:clientId/:year/:month/:stage
// -> extraction du tacheId (data.form.tacheId). Lève exactement les mêmes
// messages d'erreur que la version d'origine de chaque handler.
export async function postComptaStageForm({
  clientId,
  year,
  month,
  stage,
  payload,
  sendErrorMessage = "Erreur lors de l’envoi",
  tacheIdErrorMessage = "tacheId introuvable dans la réponse",
}) {
  const res = await authFetch(
    `https://backend-myalfa.vercel.app/api/compta/${clientId}/${year}/${month}/${stage}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );

  if (!res.ok) throw new Error(sendErrorMessage);
  const data = await res.json();

  const tacheId = data?.form?.tacheId;
  if (!tacheId) throw new Error(tacheIdErrorMessage);

  return tacheId;
}

// 3. Bloc "fire-and-forget" post-soumission : statut de la tâche, email de
// notification, puis (si prevTodoEndpoint fourni)
// fermeture du ToDo de l'étape précédente. Appelé depuis le
// `(async () => { ... })()` de chaque handler, exactement comme avant.
export async function finalizeComptaStage({
  clientId,
  tacheId,
  emailEndpoint,
  emailPayload,
  prevTodoEndpoint, // null pour arrivePC (pas d'étape précédente)
  refetch,
}) {
  // La ligne de Timeline (période, auteur, contenu du formulaire) est écrite
  // par le serveur au passage de la tâche à « faite » — voir
  // updateTacheStatut / services/timelineSuiviProd.js côté backend.
  try {
    await authFetch(`https://backend-myalfa.vercel.app/api/compta/tache/${tacheId}/statut`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
    });
  } catch {}

  try {
    await authFetch(emailEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(emailPayload),
    });
  } catch {}

  if (prevTodoEndpoint) {
    try {
      const prevTodoRes = await authFetch(prevTodoEndpoint);
      if (prevTodoRes.ok) {
        const prevTodoData = await prevTodoRes.json();
        const prevTodoId = prevTodoData?.TodoCreate;
        if (prevTodoId && String(prevTodoId).trim() !== "") {
          await authFetch(`https://backend-myalfa.vercel.app/api/todos/${prevTodoId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ comptaDext: true, status: "Terminer" }),
          });
        }
      }
    } catch {}
  }

  refetch();
}
